import { cloneDeep as clone } from 'lodash'

export default function resetStore() {
  return store => {
    const initialState = clone(store.state)

    store.subscribe(mutation => {
      if (mutation.type === 'CLEAR_STATE') {
        const newState = clone(initialState)

        store.replaceState(newState)
      }
    })
  }
}
